import {useLocation, Navigate, Outlet} from "react-router-dom";
import useAuth from "../hooks/useAuth";
import {hasAnyPermission} from "./permissions";

const RequirePermission = ({permissions, requireLinkedEmployee = false}) => {
  const {auth} = useAuth();
  const location = useLocation();
  const hasLinkedEmployee = auth?.linkedEmployee === true || auth?.employeeId != null;
  const employeeRequirementMet = !requireLinkedEmployee || hasLinkedEmployee;
  return hasAnyPermission(auth?.permissions, permissions || []) && employeeRequirementMet
    ? <Outlet />
    : auth?.user
      ? <Navigate to="/unauthorized" state={{from: location}} replace />
      : <Navigate to="/login" state={{from: location}} replace />;
};

export default RequirePermission;

